import Vue from 'vue';
import Main from './main.vue';

const ToastConstructor = Vue.extend(Main);
let zIndex = 800;

function Toast(opts = {}) {
  if (typeof opts === 'string') opts = { message: opts };
  zIndex += 1;
  const instance = new ToastConstructor({
    data: opts,
    zIndex,
  });
  instance.$mount();
  document.body.appendChild(instance.$el);
  instance.show(opts);
  return instance;
}

['info', 'success', 'error'].forEach((type) => {
  Toast[type] = (opts) => {
    if (typeof opts === 'object') {
      return Toast({
        type,
        ...opts,
      });
    }
    return Toast(
      {
        type,
        message: opts,
      },
    );
  };
});

export default Toast;
